import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_search_filter_section_RowClass, bl_fi_mst_search_filter_set_RowClass} from '../../../dbschema';

export class SearchFilterSetContainerModel extends BaseContainerModel {
  bl_fi_mst_search_filter_set: bl_fi_mst_search_filter_set_RowClass = new bl_fi_mst_search_filter_set_RowClass();
  bl_fi_mst_search_filter_sections: bl_fi_mst_search_filter_section_RowClass[] = [];
}
